// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestFilledSvg from "@fishx/icons-svg/es/asn/RestFilled";
import FishxIcon from '../components/FishxIcon';

var RestFilled = function RestFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RestFilledSvg
  }));
};

RestFilled.displayName = 'RestFilled';
export default React.forwardRef(RestFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RestFilled.js
// module id = 4006
// module chunks = 0